var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCadetsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0856 6.22227H3.85504C3.76247 6.22227 3.67175 6.19847 3.59082 6.1535C2.34218 5.45605 2.08008 4.67556 2.08008 4.14394C2.08008 2.10185 5.63 1 8.97019 1C12.3104 1 15.8603 2.10185 15.8603 4.14394C15.8603 4.67582 15.5982 5.45605 14.3498 6.1535C14.2689 6.19847 14.1782 6.22227 14.0856 6.22227ZM4.00077 5.13894H13.9399C14.4739 4.81679 14.777 4.45815 14.777 4.14394C14.777 3.28357 12.568 2.08333 8.97019 2.08333C5.3724 2.08333 3.16341 3.28357 3.16341 4.14394C3.16341 4.45815 3.46678 4.81679 4.00077 5.13894Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.95522 9.8079C7.87559 9.8079 6.7957 9.57992 5.81154 9.12368C3.20345 7.91498 2.86914 7.16119 2.86914 6.63936C2.86914 6.07839 3.06989 5.64331 3.50073 5.27065C3.59912 5.18549 3.72502 5.13867 3.85514 5.13867H14.0857C14.2161 5.13867 14.342 5.18575 14.4404 5.27091C14.9731 5.73244 15.0413 6.24475 15.0413 6.63936C15.0413 7.16119 14.707 7.91498 12.0989 9.12368C11.1147 9.57992 10.0349 9.8079 8.95522 9.8079ZM3.95247 6.63936C3.95485 6.63936 4.10799 7.14003 6.26699 8.14085C7.95018 8.92029 9.95974 8.92082 11.6435 8.14085C13.8204 7.13184 13.958 6.6309 13.959 6.62587C13.9582 6.45449 13.9413 6.33811 13.8564 6.22201H4.07969C3.97522 6.35319 3.95247 6.47565 3.95247 6.63936Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.98564 17.7293C3.83187 17.7293 3.27539 11.8008 3.27539 9.25197C3.27539 8.64365 3.37801 7.9946 3.57241 7.37544C3.66207 7.0898 3.96676 6.93084 4.25134 7.02077C4.53672 7.11043 4.69568 7.41432 4.60602 7.6997C4.44415 8.21545 4.35872 8.75209 4.35872 9.25197C4.35872 11.4752 4.80967 16.6459 8.98564 16.6459C13.1619 16.6459 13.6128 11.4752 13.6128 9.25197C13.6128 8.76003 13.5205 8.19508 13.3531 7.66135C13.2634 7.37597 13.4224 7.07208 13.7078 6.98242C13.9934 6.89302 14.2973 7.05198 14.3867 7.33709C14.5864 7.97292 14.6961 8.65317 14.6961 9.25197C14.6961 14.5602 12.5615 17.7293 8.98564 17.7293Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.95573 4.15245C8.88511 4.15245 8.81476 4.14161 8.74969 4.10908C8.6849 4.0821 8.62512 4.04401 8.57117 3.99535C8.52224 3.94113 8.48442 3.88691 8.45717 3.81656C8.4302 3.75149 8.41406 3.68114 8.41406 3.61079C8.41406 3.57297 8.41935 3.54043 8.42491 3.50235C8.4302 3.47008 8.44104 3.43755 8.45717 3.40502C8.46802 3.37249 8.48442 3.33995 8.5061 3.31298C8.52779 3.28044 8.54948 3.2532 8.57117 3.22622C8.62512 3.17756 8.6849 3.13947 8.74969 3.1125C8.87982 3.05828 9.03137 3.05299 9.1615 3.1125C9.22656 3.13947 9.28607 3.17756 9.34029 3.22622C9.36198 3.2532 9.38367 3.28044 9.40509 3.31298C9.42678 3.33995 9.44318 3.37249 9.45402 3.40502C9.47015 3.43755 9.481 3.47008 9.48655 3.50235C9.49184 3.54043 9.4974 3.57297 9.4974 3.61079C9.4974 3.68114 9.481 3.75149 9.45402 3.81656C9.42678 3.88691 9.38896 3.94113 9.34029 3.99535C9.23741 4.09294 9.09644 4.15245 8.95573 4.15245Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.3687 27.0001H1.54167C1.24253 27.0001 1 26.7578 1 26.4585V24.4431C1 21.6226 3.1783 19.0968 6.29738 18.3001C6.48755 18.2515 6.68803 18.3096 6.82292 18.4504L8.97636 20.7027L11.124 18.4583C11.2599 18.3165 11.462 18.2599 11.6519 18.3086C14.7972 19.128 16.9104 21.593 16.9104 24.4431V26.4585C16.9104 26.7578 16.6679 27.0001 16.3687 27.0001ZM2.08333 25.9168H15.8271V24.4431C15.8271 22.1844 14.174 20.2076 11.6815 19.4427L9.36753 21.8606C9.26518 21.9675 9.12394 22.0278 8.97609 22.0278C8.82825 22.0278 8.68675 21.9675 8.58466 21.8606L6.26432 19.4337C3.78741 20.1854 2.08333 22.2076 2.08333 24.4431V25.9168Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadetsIcon);
export default __webpack_public_path__ + "static/media/cadets-icon.6b66a944d489e9d2475fffb8b4e48da8.svg";
export { ForwardRef as ReactComponent };